var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],attrs:{"data-src":_vm.iframeSrc,"width":"100%","height":"820","frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }